<a [routerLink]="[]" target="_blank" mat-button class="nav-new-tab">
    <span class="fas fa-plus nav-new-tab-icon"></span>
    <span class="nav-new-tab-text">NEW</span>
</a>